
import Vue from 'vue'
import { QInput, QSelect } from 'quasar'
import gql from 'graphql-tag'
import types from '@/helpers/types'
import EntryEdit from './EntryEdit.vue'

function getEmptyEntry() {
    return {
        name: '',
        mail: '',
        type: '',
        tel: '',
        contactPerson: '',
        website: '',
        postcode: '',
        city: '',
        address: '',
        responsible: '',
        products: '',
        comment: '',
    }
}
export default Vue.extend({
    components: { QInput, QSelect, EntryEdit },
    props: {
        listId: {
          type: String
        },
        users: {
          type: Array,
          default: () => ([])
        },
    },
    data() {
      return {
        entry: getEmptyEntry(),
        isLoading: false
      }
    },

    methods: <any>{
      async saveClose() {
        const id = await this.save()
        this.$emit('closeDialog')
        this.$router.push({
            name: 'entry',
            params: {
                id: id
            }
        })
      },
      async savePlus(e: any) {
        if(e.shiftKey) return // don't submit on Shift+Enter
        if(!this.isValid) return
        await this.save()
        const type = this.entry.type
        this.entry = getEmptyEntry()
        this.entry.type = type
        this.$refs.form.focusName()
      },
      async save(): Promise<string> {
        if(this.isLoading) return ''
        this.isLoading = true
        try {
          const { data } = await this.$apollo.mutate({
            mutation: gql`
              mutation update ($data: EntryCreateInput!, $listId: String!) {
                createEntry(data: $data, listId: $listId) {
                    id
                }
              }
            `,
            variables: {
              data: this.entry,
              listId: this.listId 
            }
          })
          this.isLoading = false
          return data.createEntry.id
        } catch(err) {
          this.isLoading = false
          throw err
        }
      },
    },
    computed: {
        isValid() {
            if(!this.entry.name) return false
            if(!this.entry.type) return false
            return true
        }
    }
})

